/* KDIMZ double zoom: click product image -> lightbox (zoom 1), click again -> deep zoom (zoom 2), click again -> back */
(function () {
  if (window.kdDoubleZoomInit) return;
  window.kdDoubleZoomInit = true;

  var SCALE = 2.5;

  function clamp(v, a, b) {
    return Math.min(Math.max(v, a), b);
  }

  function init(modal) {
    if (modal.dataset.kdZoom) return;
    modal.dataset.kdZoom = '1';
    var content = modal.querySelector('.product-media-modal__content');
    if (!content) return;

    // set aspect ratio from width/height attributes so images size correctly before they load
    content.querySelectorAll(':scope > img').forEach(function (img) {
      var w = parseFloat(img.getAttribute('width'));
      var h = parseFloat(img.getAttribute('height'));
      if (w && h) img.style.setProperty('--kd-ar', (w / h).toFixed(4));
    });

    var state = null;
    var drag = null;
    var suppressClick = false;
    var busy = false;

    function isZoomable(el) {
      return el && el.tagName === 'IMG' && el.parentElement === content;
    }

    function viewport() {
      var w = document.documentElement.clientWidth;
      var h = window.innerHeight;
      return { left: 0, top: 0, right: w, bottom: h, width: w, height: h };
    }

    function setBounds(s) {
      var sw = s.w * SCALE;
      var sh = s.h * SCALE;
      if (sw >= s.vp.width) {
        s.maxTx = s.vp.left - s.base.left;
        s.minTx = s.vp.right - s.base.left - sw;
      } else {
        s.minTx = s.maxTx = s.vp.left + s.vp.width / 2 - s.base.left - sw / 2;
      }
      if (sh >= s.vp.height) {
        s.maxTy = s.vp.top - s.base.top;
        s.minTy = s.vp.bottom - s.base.top - sh;
      } else {
        s.minTy = s.maxTy = s.vp.top + s.vp.height / 2 - s.base.top - sh / 2;
      }
    }

    function apply() {
      state.img.style.transform =
        'translate3d(' + state.tx + 'px,' + state.ty + 'px,0) scale(' + SCALE + ')';
    }

    function zoomIn(img, x, y) {
      var r0 = img.getBoundingClientRect();
      var fx = clamp((x - r0.left) / r0.width, 0, 1);
      var fy = clamp((y - r0.top) / r0.height, 0, 1);

      content.classList.add('kd-zoomed');
      img.classList.add('kd-zoom-target');
      modal.classList.add('kd-zoom-active');

      var base = img.getBoundingClientRect();
      var s = { img: img, base: base, w: base.width, h: base.height, vp: viewport() };
      setBounds(s);

      // keep the clicked point under the cursor/finger
      s.tx = clamp(x - base.left - fx * s.w * SCALE, s.minTx, s.maxTx);
      s.ty = clamp(y - base.top - fy * s.h * SCALE, s.minTy, s.maxTy);
      state = s;

      // request a sharper image for the deep zoom
      if (!img.dataset.kdSizes) img.dataset.kdSizes = img.getAttribute('sizes') || '';
      img.setAttribute('sizes', Math.round(s.w * SCALE) + 'px');

      // force reflow so the transition runs from scale(1)
      void img.offsetWidth;
      apply();

      busy = true;
      setTimeout(function () {
        busy = false;
        if (state && state.img === img) img.classList.add('kd-zoom-live');
      }, 360);
    }

    function cleanup(img) {
      img.classList.remove('kd-zoom-target', 'kd-zoom-live', 'kd-dragging');
      img.style.transform = '';
      content.classList.remove('kd-zoomed');
      modal.classList.remove('kd-zoom-active');
    }

    function zoomOut(animate) {
      if (!state) return;
      var img = state.img;
      state = null;
      drag = null;
      if (!animate) {
        cleanup(img);
        return;
      }
      img.classList.remove('kd-zoom-live', 'kd-dragging');
      img.style.transform = 'translate3d(0,0,0) scale(1)';
      busy = true;
      setTimeout(function () {
        cleanup(img);
        busy = false;
        img.scrollIntoView({ block: 'center' });
      }, 320);
    }

    // Dawn closes the lightbox on any mouse pointerup - stop that when the image itself is clicked
    content.addEventListener('pointerup', function (e) {
      if (isZoomable(e.target)) e.stopPropagation();
    });

    content.addEventListener('click', function (e) {
      if (!isZoomable(e.target)) return;
      if (suppressClick) {
        suppressClick = false;
        return;
      }
      if (busy) return;
      if (state) zoomOut(true);
      else zoomIn(e.target, e.clientX, e.clientY);
    });

    content.addEventListener('pointerdown', function (e) {
      if (!state || e.pointerType === 'mouse' || e.target !== state.img) return;
      drag = { id: e.pointerId, x: e.clientX, y: e.clientY, tx: state.tx, ty: state.ty, moved: false };
      state.img.classList.add('kd-dragging');
      try {
        state.img.setPointerCapture(e.pointerId);
      } catch (err) {}
    });

    content.addEventListener('pointermove', function (e) {
      if (!state) return;
      if (e.pointerType === 'mouse') {
        // desktop: image follows the mouse
        var fx = clamp((e.clientX - state.vp.left) / state.vp.width, 0, 1);
        var fy = clamp((e.clientY - state.vp.top) / state.vp.height, 0, 1);
        state.tx = state.maxTx + (state.minTx - state.maxTx) * fx;
        state.ty = state.maxTy + (state.minTy - state.maxTy) * fy;
        apply();
        return;
      }
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x;
      var dy = e.clientY - drag.y;
      if (Math.abs(dx) + Math.abs(dy) > 6) drag.moved = true;
      state.tx = clamp(drag.tx + dx, state.minTx, state.maxTx);
      state.ty = clamp(drag.ty + dy, state.minTy, state.maxTy);
      apply();
    });

    function endDrag(e) {
      if (!drag || e.pointerId !== drag.id) return;
      if (drag.moved) {
        suppressClick = true;
        setTimeout(function () {
          suppressClick = false;
        }, 350);
      }
      if (state) state.img.classList.remove('kd-dragging');
      drag = null;
    }
    content.addEventListener('pointerup', endDrag);
    content.addEventListener('pointercancel', endDrag);

    // reset when the lightbox closes
    new MutationObserver(function () {
      if (!modal.hasAttribute('open')) zoomOut(false);
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });

    window.addEventListener('resize', function () {
      if (state) zoomOut(false);
    });
  }

  function boot() {
    document.querySelectorAll('product-modal').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
